import React, { Component } from "react";
import "../../../../public/styles/HomeInteriors/LocateUs/LocateUsForm.scss";



import Button from 'react-bootstrap/lib/Button'
import Col from 'react-bootstrap/lib/Col'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import Label from 'react-bootstrap/lib/Label'
import FormControl from 'react-bootstrap/lib/FormControl'


import { imagePrefix, HIConsultFormAPI } from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";
import {
  validateEmptyObject,
  validateFullName,
  regexName,
  regexMobileNo,
  regexEmail,
} from "../../../utils/validationManager";
import {
  FIELDREQ_MSG,
  NAME_VALIDATION_MSG,
  INVALID_MOBILE_NUMBER,
  INVALID_EMAIL_ADDRESS,
} from "../../../constants/app/primitivesConstants";
import { isMobile } from "../../../utils/utilityManager";

export default class FormLocateUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "",
      title1: "DID NOT FIND US IN YOUR CITY?",
      title2: "We've get you covered!",
      title3: "Just submit your details below to get a callback from us",
      buttonTxt: "Book an appointment",
      name: null,
      email1: null,
      mobile: null,
      city: null,
      nameErrMsg: null,
      emailErrMrg: null,
      mobileErrMrg: null,
      cityErrMrg: null,
      contactWA: true,
      submit: false,
      successMsg: "",
      errorMsg: "",
    };
  }






  submitForm = e => {
    e.preventDefault();
    console.log(JSON.stringify(this.state,null,2))
    if (!this.formValidationHandler()) {
      return;
    }
    this.setState({
      submit: true,
    });
    setTimeout(() => {
      this.setState({
        submit: false,
      });
    }, 4000);
    const urlSearchParams = new URLSearchParams(
      window.location.search.substring(1)
    );
    const data = {
      location:this.state.city,
      name: this.state.name,
      phone1: this.state.mobile,
      contact: this.state.contactWA == false ? "No" : "Yes",
      // contact: "No",
      email1: this.state.email1,
      budget: "-",
      interests:"-",
      formName: "HI_CityNotFound",
      pageName: "HI_LocateUs",
      utmPlacement: urlSearchParams.get("utm_placement"),
      utmMedia: urlSearchParams.get("utm_medium"),
      utmKeyword: urlSearchParams.get("utm_keyword"),
      utmAddgroup: urlSearchParams.get("utm_adgroup"),
      utmCampaign: urlSearchParams.get("utm_campaign"),
      utmSource: urlSearchParams.get("utm_source") || "Website",
    };
    apiManager
      .post(HIConsultFormAPI, data)
      .then(response => {
        const resData = response.data;
        // alert(JSON.stringify(resData, null, 2));
        setTimeout(() => {
          this.setState({
            submit: false,
          });
        }, 4000);
        if (resData.data.unificationSaved == true) {
          this.setState({
            name: "",
            phone1: "",
            email1: "",
            budget: "",
            interests: "",
            location: "",
            budget: "",
            checkedInterests: [],
            // requirements: [],
            successMsg:
              "Thank You! Your nearest store representative will reach out to you shortly.",
          });
        } else {
          this.setState({
            errorMsg: "Unable to save your data. Sorry for inconvenience.",
          });
        }
      })
      .catch(e => {
        this.setState({
          // errorMsg: "Error:Unable to save your data. Sorry for inconvenience."
          errorMsg: e,
        });
      });

    // console.log(JSON.stringify(data, null, 2));
  };




  fieldChangeHandler = e => {
    this.setState({
      [e.target.name]: e.target.value !== "" ? e.target.value : null,
    });
    console.log(`${e.target.name  } ${  e.target.value}`)
  };

  checkedContact = e => {
    this.setState({
      contactWA: !this.state.contactWA,
    });
  };


  formValidationHandler = () => {
    this.setState({
      nameErrMsg: null,
      emailErrMsg: null,
      mobileErrMsg: null,
      
      successMsg: null,
      checkInterestErrMsg: null,
      errorMsg: null,
    });
    let isValid = true;
    const {
      name,
      email1,
      mobile,
      city,
      requirements,
    } = this.state;
    if (!validateEmptyObject(name)) {
      this.setState({ nameErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!validateFullName(name) || !regexName.test(name)) {
      this.setState({ nameErrMsg: NAME_VALIDATION_MSG });
      isValid = false;
    }
    if (!validateEmptyObject(email1)) {
      this.setState({ emailErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!regexEmail.test(email1)) {
      this.setState({ emailErrMsg: INVALID_EMAIL_ADDRESS });
      isValid = false;
    }
    if (!validateEmptyObject(mobile)) {
      this.setState({mobileErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!regexMobileNo.test(mobile)) {
      this.setState({ mobileErrMsg: INVALID_MOBILE_NUMBER });
      isValid = false;
    }
    if (!validateEmptyObject(city)) {
      this.setState({ cityErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!validateFullName(city) || !regexName.test(city)) {
      this.setState({ cityErrMsg: NAME_VALIDATION_MSG });
      isValid = false;
    }
    
   

    return isValid;
  };

  //   getEspotData() {
  //     apiManager
  //       .get(espotAPI + this.state.espotName)
  //       .then(response => {
  //         const { data } = response || {};
  //         this.setState({
  //           title1: data.data && data.data.title1,
  //           title2: data.data && data.data.title2
  //         });
  //       })
  //       .catch(error => {
  //         this.setState({
  //           error,
  //           isLoading: false
  //         });
  //       });
  //   }

  //   componentDidMount(){
  //     this.getEspotData()
  //   }

  render() {
    const {
      name,
      email1,
      mobile,
      city,
      emailErrMsg,
      mobileErrMsg,
      cityErrMsg,
      nameErrMsg,
      successMsg,
      errorMsg,
      contactWA,
    } = this.state;
    return (
      <div className="locator-form-container">
        <div className="locator-form-wrapper">
          <div className="header-container">
            <div className="header-wrapper">
              <div className="header-left">
                <h3>{this.state.title1}</h3>
              </div>
              <div className="header-right">
                <span>{this.state.title2}</span> <br />
                <span>{this.state.title3}</span>
              </div>
            </div>
          </div>
          <div className="form-body-container">
            <div className="form-body-wrapper">
              <form className="form-box" method="POST">
                <div className="form-input">
                  <Col xs={12}>
                    <FormGroup>
                      <Label>
                        Name * <p className="error-msg">{nameErrMsg}</p>
                      </Label>

                      <FormControl
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter Full Name"
                        value={name}
                        required
                        onChange={this.fieldChangeHandler}
                        onKeyPress={this.fieldChangeHandler}
                      />
                    </FormGroup>
                  </Col>
                </div>
                <div className="form-input">
                  <Col xs={12}>
                    <FormGroup>
                      <Label>
                        Email * <p className="error-msg">{emailErrMsg}</p>
                      </Label>

                      <FormControl
                        type="text"
                        name="email1"
                        className="form-control"
                        placeholder="Please enter your email here"
                        value={email1}
                        required
                        onChange={this.fieldChangeHandler}
                        onKeyPress={this.fieldChangeHandler}
                      />
                    </FormGroup>
                  </Col>
                </div>
                {isMobile() ? (
                  <Col xs={12}>
                    <FormGroup className="contact-box">
                      <FormControl
                        value={contactWA}
                        onChange={this.checkedContact}
                        type="checkbox"
                        name="contactWA"
                        defaultChecked
                      />
                      <Label htmlFor="contactWA">Contact me on Whatsapp</Label>
                    </FormGroup>
                  </Col>
                ) : (
                  <></>
                )}

                <div className="form-input">
                  <Col xs={12}>
                    <FormGroup>
                      <Label>
                        Mobile Number *{" "}
                        <p className="error-msg">{mobileErrMsg}</p>
                      </Label>

                      <FormControl
                        type="text"
                        name="mobile"
                        className="form-control"
                        placeholder="Number"
                        value={mobile}
                        required
                        onChange={this.fieldChangeHandler}
                        onKeyPress={this.fieldChangeHandler}
                      />
                    </FormGroup>
                  </Col>
                </div>
                <div className="form-input">
                  <Col xs={12}>
                    <FormGroup>
                      <Label>
                        City * <p className="error-msg">{cityErrMsg}</p>
                      </Label>

                      <FormControl
                        type="text"
                        name="city"
                        className="form-control"
                        placeholder="Please enter the name of city you are from"
                        value={city}
                        required
                        onChange={this.fieldChangeHandler}
                        onKeyPress={this.fieldChangeHandler}
                      />
                    </FormGroup>
                  </Col>
                </div>
                {!isMobile() ? (
                  <Col xs={12}>
                    <FormGroup className="contact-box">
                      <FormControl
                        value={contactWA}
                        onChange={this.checkedContact}
                        type="checkbox"
                        name="contactWA"
                        defaultChecked
                      />
                      <Label htmlFor="contactWA">Contact me on Whatsapp</Label>
                    </FormGroup>
                  </Col>
                ) : (
                  <></>
                )}
                <div className="form-footer">
                  <Button
                    disabled={this.state.submit}
                    className="button-submit"
                    onClick={this.submitForm}>{this.state.buttonTxt}</Button>
                  <span>
                    By submitting this form you agree to the{" "}
                    <a
                      target="_blank"
                      href={
                        `${imagePrefix 
                        }/B2C/homeinteriors/footer/pdf/Privacy_Policy.pdf`
                      }
                    >
                      privacy policy
                    </a>
                  </span>
                  <p className="error-msg">{errorMsg}</p>
                  {/* <p className="success-msg">{successMsg}</p> */}
                  {successMsg
                    ? (window.location.pathname = "/thank-you-homeinteriors")
                    : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
